export enum SaleScope {
  Group = 'group',
  Participation = 'participation',
}
